import { render, staticRenderFns } from "./RelatorioDam.vue?vue&type=template&id=46cefcae&scoped=true&"
import script from "./RelatorioDam.vue?vue&type=script&lang=js&"
export * from "./RelatorioDam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cefcae",
  null
  
)

export default component.exports